export const ROLES = {
    USER: 'user',
    REGULAR_GUEST: 'regular-guest',
    DERTIGEN_USER: 'dertigen-user',
    ADMIN: 'admin',
    RULE_BOSS: 'rule-boss',
    GUEST: 'guest',
} as const;

export const APP_ROLES = [
    ROLES.USER,
    ROLES.REGULAR_GUEST,
    ROLES.DERTIGEN_USER,
    ROLES.ADMIN,
    ROLES.RULE_BOSS,
    ROLES.GUEST,
] as const;

export const MENU_MEMBER_ROLES = [ROLES.USER, ROLES.REGULAR_GUEST] as const;
export const ACCOUNT_ROLES = [ROLES.USER, ROLES.REGULAR_GUEST, ROLES.DERTIGEN_USER] as const;

export type Role = typeof APP_ROLES[number];

export const hasRole = (roles: readonly string[] | undefined, role: string): boolean => {
    if (!roles?.length) {
        return false;
    }
    return roles.includes(role);
};

export const hasAnyRole = (roles: readonly string[] | undefined, allowedRoles: readonly string[]): boolean => {
    if (!roles?.length || !allowedRoles.length) {
        return false;
    }
    return allowedRoles.some((role) => roles.includes(role));
};